import type { AgendaEvent } from "../../types";
import { StarMark } from "../ui/StarMark";
import "./AgendaSection.css";
import { assetUrl, siteUrl } from "../../wordpress";

type AgendaSectionProps = {
	events: AgendaEvent[];
	title?: string;
};

/**
 * Agenda: três cartões lado a lado. O grid mantém-nos com a mesma altura;
 * abaixo de 768px empilham-se e cada um volta a ter a altura do seu conteúdo.
 */
export function AgendaSection({
	events,
	title = "Agenda Cosa Nova",
}: AgendaSectionProps) {
	if (events.length === 0) return null;

	return (
		<section className="agenda" id="agenda" aria-labelledby="agenda-title">
			<h2 className="agenda__title" id="agenda-title">
				<StarMark className="agenda__star" />
				{title}
			</h2>

			<ul className="agenda__grid">
				{events.map((event) => (
					<li className="agenda__item" key={event.id}>
						<AgendaCard event={event} />
					</li>
				))}
			</ul>
		</section>
	);
}

function AgendaCard({ event }: { event: AgendaEvent }) {
	return (
		<article className="agenda-card">
			<h3 className="agenda-card__title">{event.title}</h3>
			<p className="agenda-card__subtitle">{event.subtitle}</p>
			<p className="agenda-card__description">{event.description}</p>
			<p className="agenda-card__when">
				<em>{event.venue}</em> · {event.schedule}
			</p>
			<a className="agenda-card__mark" href={siteUrl(event.href)}>
				<img src={assetUrl("/assets/CosanovaStarBlue.png")} alt="" aria-hidden="true" />
				<span className="visually-hidden">{event.title}</span>
			</a>
		</article>
	);
}
